// src/ai/helpers.js

import { startOfDay, endOfDay, startOfWeek, endOfWeek, startOfMonth, endOfMonth, subMonths } from 'date-fns';

export const numberToTurkishWords = (num) => {
    if (num < 0) return "eksi " + numberToTurkishWords(Math.abs(num));
    if (num === 0) return 'sıfır';
    const units = ['', 'bir', 'iki', 'üç', 'dört', 'beş', 'altı', 'yedi', 'sekiz', 'dokuz'];
    const tens = ['', 'on', 'yirmi', 'otuz', 'kırk', 'elli', 'altmış', 'yetmiş', 'seksen', 'doksan'];
    const thousands = ['', 'bin', 'milyon', 'milyar'];
    let words = [];
    const processGroup = (group) => {
        let groupWords = [];
        const hundred = Math.floor(group / 100);
        const ten = Math.floor((group % 100) / 10);
        const unit = group % 10;
        if (hundred > 0) { groupWords.push(hundred > 1 ? units[hundred] : '', 'yüz'); }
        if (ten > 0) { groupWords.push(tens[ten]); }
        if (unit > 0) { groupWords.push(units[unit]); }
        return groupWords.join(' ');
    };
    let i = 0;
    while (num > 0) {
        const group = num % 1000;
        if (group > 0) {
            let groupStr = processGroup(group);
            if (thousands[i]) {
                 if (group === 1 && i === 1) { groupStr = thousands[i]; }
                 else { groupStr += ' ' + thousands[i]; }
            }
            words.unshift(groupStr);
        }
        num = Math.floor(num / 1000);
        i++;
    }
    return words.join(' ').trim();
};

export const getTimeframeFromCommand = (command) => {
    const now = new Date();
    if (command.includes('bugün') || command.includes('bu gün')) return { start: startOfDay(now), end: endOfDay(now), name: "Bugün" };
    if (command.includes('yarın')) { const start = new Date(now); start.setDate(now.getDate() + 1); const end = new Date(now); end.setDate(now.getDate() + 1); return { start: startOfDay(start), end: endOfDay(end), name: "Yarın" }; }
    if (command.includes('bu ay')) return { start: startOfMonth(now), end: endOfMonth(now), name: "Bu Ay" };
    if (command.includes('bu hafta')) return { start: startOfWeek(now, { weekStartsOn: 1 }), end: endOfWeek(now, { weekStartsOn: 1 }), name: "Bu Hafta" };
    if (command.includes('geçen ay')) return { start: startOfMonth(subMonths(now, 1)), end: endOfMonth(subMonths(now, 1)), name: "Geçen Ay" };
    return null;
};

// GÜNCELLENDİ: Rapor komutları daha öncelikli hale getirildi.
export const getMetricFromCommand = (command) => {
    // Aksiyon Komutları
    if (command.includes('durumunu') && command.includes('yap')) return 'update_service_status';
    if (command.includes('yeni ön görüşme oluştur')) return 'create_pre_interview';
    
    // Raporlama Komutları (Daha spesifik hale getirildi)
    if (command.includes('raporla') || command.includes('özetle') || command.includes('durumu raporla')) return 'daily_report';

    // Sorgu Komutları
    if (command.includes('seri numaralı cihaz')) return 'device_owner_lookup';
    if (command.includes('telefon numarası')) return 'customer_phone_lookup';
    if (command.includes('kaç tane') || command.includes('kaç adet')) return 'service_count_query';
    if (command.includes('borcu') || command.includes('cari') || command.includes('hesab')) return 'customer_balance';
    if (command.includes('randevu')) return 'appointments';
    if (command.includes('kazandık') || command.includes('kazanç') || command.includes('ciro') || command.includes('tahsilat')) return 'earnings';
    if ((command.includes('servis') && command.includes('durum')) || command.includes('işler ne durumda')) return 'service_status';
    if (command.includes('ön görüşme') || command.includes('geri ara')) return 'pre_interviews';
    
    return 'summary'; // Varsayılan
};